/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'

import schedule from '@/lib/schedule'
import { getSnapshotStatus } from '@/reducers/snapshotStatus'
import { fetchSnapshotStatus } from '@/actions/snapshots'
import { fetchSnapshotStatusRequest } from '@/reducers/asyncRequests/registry'

import SnapshotInProgress from './SnapshotInProgress'
import { StateProps, DispatchProps, ConsumerProps, AllProps } from './types'

import type { ReduxState } from '@/types/redux'

const mapStateToProps = (
  state: ReduxState,
  { deployment, snapshotName }: ConsumerProps,
): StateProps => ({
  snapshotStatus: getSnapshotStatus(state, deployment.id, snapshotName),
  fetchSnapshotStatusRequest: fetchSnapshotStatusRequest(state, deployment.id, snapshotName),
})

const scheduledComponent = schedule<AllProps>(
  SnapshotInProgress,
  ({ deployment, snapshotName, fetchSnapshotStatus }) =>
    fetchSnapshotStatus({ deployment, snapshotName }),
)

export default connect<StateProps, DispatchProps, ConsumerProps>(mapStateToProps, {
  fetchSnapshotStatus,
})(scheduledComponent)
